function ErrorService () {
  this.handlers = [];
}

ErrorService.prototype.use = function (handler) {
  this.handlers.push({
    handle: handler
  });
};

ErrorService.prototype.handle = function (error) {
  const errors = (typeof error != "undefined" && error instanceof Array ) ? error : [error];
    
  errors
    .forEach(e =>
      this.handlers
        .forEach(handler => handler.handle(e))
    );
};

const createErrorService = () => {
  return new ErrorService();
};

export {
  createErrorService
};
